// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"b9d197ca6bf9598c","931":"6716a3fc248a1c3b"}[chunkId] + ".css";
};